<template>
  <div>
    <template v-if="count">
      <el-table
        v-loading="isLoading"
        :data="list"
        highlight-current-row
      >
        <v-column-time value="访问时间"/>

        <el-table-column label="访问页面" width="164px">
          <template v-slot="{ row }">
            {{ row.page_name || '' }}
          </template>
        </el-table-column>

        <el-table-column label="相关门店" width="164px">
          <template v-slot="{ row }">
            {{ row.store_name || '-' }}
          </template>
        </el-table-column>

        <v-column-avatar label="相关老师" avatar-key="teacher_avatar" nickname-key="teacher_nickname"/>

        <el-table-column label="相关视频">
          <template v-slot="{ row }">
            {{ row.title || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无小程序访问记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { getStudentPageRecords } from "@/api/student";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    isLoading: false,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [8, 12, 16, 18],
  }),
  methods: {
    async getList() {
      const { isError, data } = await getStudentPageRecords({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
